import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';

import { AssigneesComponentModule } from '@core/components/inputs/assignees/assignees.module';
import { CompaniesComponentModule } from '@core/components/inputs/companies/companies.module';
import { LocationsComponentModule } from '@core/components/inputs/locations/locations.module';
import { RequestersComponentModule } from '@core/components/inputs/requesters/requesters.module';
import { SegmentsModule } from '@core/components/inputs/segments/segments.module';
import { StatusModule } from '@core/components/inputs/status/status.module';

import { PipesModule } from '@fuse/pipes/pipes.module';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { ScheduleSuggestionsModule } from 'app/main/maintenances/components/schedule-suggestions/schedule-suggestions.module';
import { TabGeneralComponent } from './tab-general.component';

@NgModule({
  entryComponents: [
    TabGeneralComponent
  ],
  declarations: [
    TabGeneralComponent
  ],
  imports: [
    TranslateModule,

    FuseSharedModule,

    MatIconModule,
    MatToolbarModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatTooltipModule,
    MatDatepickerModule,
    NgxMaskModule.forRoot(),

    SegmentsModule,
    RequestersComponentModule,
    StatusModule,
    AssigneesComponentModule,
    LocationsComponentModule,
    CompaniesComponentModule,
    DateTimePickerModule,
    ScheduleSuggestionsModule,
    PipesModule
  ],
  exports: [
    TabGeneralComponent
  ],
})
export class TabReallocateMaintenanceModule {
}
